import celluloid from "../../images/celluloid.gif";
import shoes from "../../images/shoe.gif";
import covid from "../../images/Covid.gif";
import music from "../../images/Music.gif";
import weather from "../../images/Weather.gif";
import players from "../../images/player_transfer.gif";
export const project = [
  {
    image: celluloid,
    name: "Celluloid Studios",
    description:
      "A MERN Stack single page photography service app where user are able buy any service with their information and leave a review of the service",
    technology: [
      "React.js",
      "React-Router",
      "React Bootstrap",
      "CDBReact",
      "Firebase Authentication",
      "Stripe.js",
      "Node.js",
      "Express.js",
      "MongoDB",
    ],
    github: "https://github.com/Fahim04blue/Celluloid-Studios-Client",
    live: "https://celluloid-studios.web.app/",
  },
  {
    image: shoes,
    name: "Anayra's Shoe Rack",
    description:
      "A MERN Stack single page an E-commerce website for buying shoes of different brands, e.g., Nike, Adidas, Puma etc.",
    technology: [
      "React.js",
      "React-Router",
      "Material UI",

      "Firebase Authentication",

      "Node.js",
      "Express.js",
      "MongoDB",
    ],
    github: "https://github.com/Fahim04blue/Anayra-s-Shoe-Rack-Client",
    live: "https://anayaras-shoe-rack.web.app/",
  },
  {
    image: covid,
    name: "COVID-19 TRACKER",
    description:
      "A Covid-19 Tracker App I built using React.js.Some key aspects of the application are: live cases, recoveries, and deaths on clickable tabs ,Global cases, recoveries, and deaths and Country-based cases, recoveries, and deaths  ",
    technology: [
      "React.js",
      "React Chartjs 2",
      "React Leaflet",
      "Material UI",
      "Numeral.js",
    ],
    github: "https://github.com/Fahim04blue/Covid-19-Tracker",
    live: "https://covid-19-tracker-bd.web.app/",
  },
  {
    image: music,
    name: "Hard Rock Music",
    description:
      "A music search website where user can search their favorite songs and listen to them.They can also see the lyrics of the song",
    technology: ["HTML5", "CSS3", "JavaScript"],
    github: "https://github.com/Fahim04blue/Celluloid-Studios-Client",
    live: "https://fahim04blue.github.io/Music-API/",
  },
  {
    image: weather,
    name: "Open Weather App",
    description:
      "A weather update website where user can search for any city's current weather.Search the city and it will show the current weather",
    technology: ["HTML5", "CSS3", "JavaScript"],
    github: "https://github.com/Fahim04blue/Weather-App",
    live: "https://fahim04blue.github.io/Weather-App/",
  },
  {
    image: players,
    name: "Hero Player Transfer",
    description:
      "A player transfer budget calculation Website. User can select a player only one time in their club",
    technology: ["React.js", "CSS3"],
    github: "https://github.com/Fahim04blue/Player-Transfer",
    live: "https://hero-player-transfer.netlify.app/",
  },
];
